<div *ngIf="!!this.case">
    <div style="min-width: 100%; display: flex; align-items: center; flex-wrap: nowrap; justify-content: flex-end;"
        class="gap-1em flex-row start-center">

        <!-- ////////////////////////// PRACTICES //////////////////// -->
        <div class="flex-row start-center" style="place-items: center; justify-content: flex-start;
            background-color: var(--color-surface-indicator); min-width: 45%;
            border-radius: 1rem; box-shadow: var(--shadow-elevation-7);">
            <!-- Vertical Tag -->
            <div style="display: flex; justify-content: center; width: auto; height: 100%;">
                <span
                    style="writing-mode: vertical-lr; transform: rotate(180deg); font-size: 12px; color: var(--color-text-primary)">{{ ('modules.cases.case-indicators.practice.title' | exp:'':'Prácticas') }}</span>
            </div>
            <!-- Provisions without attentions -->
            <app-theme-card themeScope="cases" [fullWidth]="false" cardClass="flex-column align-center-center">
                <div [class.cursor-pointer]="this.counterProvisionsWithoutAttenttions != 0"
                    (click)="counterProvisionsWithoutAttenttions !== 0 && goToScreen(ViewManagementEntities.PRACTICES_WITHOUT_SCHEDULE, practicesWithoutScheduleFlow)"
                    style="min-width: auto;" class="flex-column align-center-center">
                    <div class="number-container">
                        <ng-container
                            *ngIf="this.isCounterProvisionsWithoutAttenttions && !this.btnsDisabled && !(anyPending$ | async) else loadingProvisions">
                            <span class="mat-display-1 number-font big-number"
                                [style.color]="this.colorProvisionsWithoutAttentions">
                                {{ isCounterProvisionsWithoutAttenttions && !btnsDisabled ?
                                this.counterProvisionsWithoutAttenttions : '-' }}
                            </span>
                        </ng-container>
                        <ng-template #loadingProvisions>
                            <mat-spinner class="mr-3" color="primary" diameter="30"></mat-spinner>
                        </ng-template>
                    </div>
                    <div class="text-container flex-column align-center-center">
                        <span class="text-title">{{ ('modules.cases.case-indicators.practice.practices-without-schedule' | exp:'':'Prácticas sin agenda') }}</span>
                    </div>
                </div>
            </app-theme-card>
            <!-- Attentions old and omitted -->
            <app-theme-card themeScope="cases" [fullWidth]="false" cardClass="flex-column align-center-center">
                <div [class.cursor-pointer]="this.counterAttentionsOldAndOmitted != 0" (click)="counterAttentionsOldAndOmitted !== 0 && goToScreen(ViewManagementEntities.ATTENTIONS_OLD_AND_OMITTED, attentionsOldAndOmittedFlow)"
                    class="flex-column align-center-center cursor-pointer">
                    <div class="number-container">
                        <ng-container *ngIf="this.isCounterAttentionsOldAndOmitted && !this.btnsDisabled else loadingOldAndEmittedAttentions">
                            <span class="mat-display-1 number-font big-number"
                                [style.color]="this.colorAttentionsOldAndOmitted">
                                {{ isCounterAttentionsOldAndOmitted && !btnsDisabled ?
                                this.counterAttentionsOldAndOmitted : '-' }}
                            </span>
                        </ng-container>
                        <ng-template #loadingOldAndEmittedAttentions>
                            <mat-spinner class="mr-3" color="primary" diameter="30"></mat-spinner>
                        </ng-template>
                    </div>
                    <div class="text-container flex-column align-center-center">
                        <span class="text-title">{{ ('modules.cases.case-indicators.practice.attentions-old-and-omitted' | exp:'':'Atenciones sin finalizar') }}</span>
                    </div>
                </div>
            </app-theme-card>
            <!-- Attentions without billing -->
            <app-theme-card themeScope="cases" [fullWidth]="false" cardClass="flex-column align-center-center">
                <div [class.cursor-pointer]="this.counterAttentionsWithoutBilling != 0"   (click)="this.counterAttentionsWithoutBilling !== 0 && goToScreen(ViewManagementEntities.ATTENTIONS_WITHOUT_BILLING, attentionsWithoutBillingFlow)"
                    class="flex-column align-center-center cursor-pointer">
                    <div class="number-container">
                        <ng-container
                            *ngIf="this.isCounterAttentionsWithoutBilling && !this.btnsDisabled else loadingAttentionsWithoutBill">
                            <span class="mat-display-1 number-font big-number"
                                [style.color]="this.colorAttentionsWithoutBilling">
                                {{ isCounterAttentionsWithoutBilling && !btnsDisabled ?
                                this.counterAttentionsWithoutBilling : '-' }}
                            </span>
                        </ng-container>
                        <ng-template #loadingAttentionsWithoutBill>
                            <mat-spinner class="mr-3" color="primary" diameter="30"></mat-spinner>
                        </ng-template>
                    </div>
                    <div class="text-container flex-column align-center-center">
                        <span class="text-title">{{ ('modules.cases.case-indicators.practice.attentions-without-billing' | exp:'':'Atenciones sin facturar') }}</span>
                    </div>
                </div>
            </app-theme-card>
            <!-- Billing Attentions -->
            <app-theme-card themeScope="cases" [fullWidth]="false" cardClass="flex-column align-center-center">
                <div [class.cursor-pointer]="this.counterBillingAttentions != 0"  (click)="this.counterBillingAttentions !== 0 && goToScreen(ViewManagementEntities.BILLING_ATTENTIONS)"
                    class="flex-column align-center-center cursor-pointer">
                    <div class="number-container">
                        <ng-container
                            *ngIf="this.isCounterBillingAttentions && !this.btnsDisabled else loadingBillingAttentions">
                            <span class="mat-display-1 number-font big-number"
                                [style.color]="this.colorBillingAttentions">
                                {{ isCounterBillingAttentions && !btnsDisabled ? this.counterBillingAttentions : '-' }}
                            </span>
                        </ng-container>
                        <ng-template #loadingBillingAttentions>
                            <mat-spinner class="mr-3" color="primary" diameter="30"></mat-spinner>
                        </ng-template>
                    </div>
                    <div class="text-container flex-column align-center-center">
                        <span class="text-title">{{ ('modules.cases.case-indicators.practice.billing-attentions' | exp:'':'Atenciones sin informar') }}</span>
                    </div>
                </div>
            </app-theme-card>
            <!-- Modules Without Billing Attentions -->
            <app-theme-card themeScope="cases" [fullWidth]="false" cardClass="flex-column align-center-center"
                [cardStyle]="{ width: 'auto', height: '98%', 'border-radius': '0 1rem 1rem 0' }">
                <div [class.cursor-pointer]="this.counterModulesWithoutBillingAttentions != 0"  (click)="this.counterModulesWithoutBillingAttentions !== 0 && goToScreen(ViewManagementEntities.MODULES_WITHOUT_BILLING_ATTENTIONS)"
                    class="flex-column align-center-center cursor-pointer">
                    <div class="number-container">
                        <ng-container
                            *ngIf="this.isCounterModulesWithoutBillingAttentions && !this.btnsDisabled else loadingModulesWithoutBillingAttentions">
                            <span class="mat-display-1 number-font big-number"
                                [style.color]="this.colorModulesWithoutBillingAttentions">
                                {{ isCounterModulesWithoutBillingAttentions && !btnsDisabled ? this.counterModulesWithoutBillingAttentions : '-' }}
                            </span>
                        </ng-container>
                        <ng-template #loadingModulesWithoutBillingAttentions>
                            <mat-spinner class="mr-3" color="primary" diameter="30"></mat-spinner>
                        </ng-template>
                    </div>
                    <div class="text-container flex-column align-center-center">
                        <span class="text-title">{{ ('modules.cases.case-indicators.practice.modules-without-billing-attentions' | exp:'':'Modulos sin aten. de fact.') }}</span>
                    </div>
                </div>
            </app-theme-card>
        </div>

        <!-- ////////////////////////// SUPPLIES //////////////////// -->
        <div class="flex-row start-center"
            style="place-items: center; justify-content: flex-start;
            min-width: 45%; background-color: var(--color-surface-indicator);
            border-radius: 1rem; box-shadow: var(--shadow-elevation-7);">
            <!-- SUPPLY CARDS -->
            <!-- Provisions without attentions -->
            <div style="display: flex; justify-content: center; width: auto; height: 100%;">
                <!-- Texto centrado -->
                <span
                    style="writing-mode: vertical-lr; transform: rotate(180deg); font-size: 12px; color: var(--color-text-primary)">{{ ('modules.cases.case-indicators.supply.title' | exp:'':'Insumos') | titlecase }}</span>
            </div>
            <app-theme-card themeScope="cases" [fullWidth]="false" cardClass="flex-column align-center-center">
                <div [class.cursor-pointer]="this.counterSuppliesWithoutOrder != 0"
                    (click)="this.counterSuppliesWithoutOrder !== 0 && goToScreen(ViewManagementEntities.SUPPLIES_WITHOUT_ORDER, suppliesWithoutOrderFlow)"
                    class="flex-column align-center-center cursor-pointer">
                    <div class="number-container">
                        <ng-container
                            *ngIf="this.isCounterSuppliesWithoutOrder && !this.btnsDisabled else loadingSuppliesWithoutOrder">
                            <span class="mat-display-1 number-font big-number"
                                [style.color]="this.colorSuppliesWithoutOrder">
                                {{ isCounterSuppliesWithoutOrder && !btnsDisabled ? this.counterSuppliesWithoutOrder :
                                '-' }}
                            </span>
                        </ng-container>
                        <ng-template #loadingSuppliesWithoutOrder>
                            <mat-spinner class="mr-3" color="primary" diameter="30"></mat-spinner>
                        </ng-template>
                    </div>
                    <div class="text-container flex-column align-center-center">
                        <span class="text-title">{{ ('modules.cases.case-indicators.supply.supplies-without-order' | exp:'':'Insumos no pedidos') }}</span>
                    </div>
                </div>
            </app-theme-card>
            <!-- Attentions old and omitted -->
            <app-theme-card themeScope="cases" [fullWidth]="false" cardClass="flex-column align-center-center">
                <div [class.cursor-pointer]="this.counterSuppliesNotDelivered != 0"  (click)="this.counterSuppliesNotDelivered !== 0 && goToScreen(ViewManagementEntities.SUPPLIES_NOT_DELIVERED, suppliesNotDeliveredFlow)"
                    class="flex-column align-center-center cursor-pointer">
                    <div class="number-container">
                        <ng-container
                            *ngIf="this.isCounterSuppliesNotDelivered && !this.btnsDisabled else loadingSuppliesNotDelivered">
                            <span class="mat-display-1 number-font big-number"
                                [style.color]="this.colorSuppliesNotDelivered">
                                {{ isCounterSuppliesNotDelivered && !btnsDisabled ? this.counterSuppliesNotDelivered :
                                '-' }}
                            </span>
                        </ng-container>
                        <ng-template #loadingSuppliesNotDelivered>
                            <mat-spinner class="mr-3" color="primary" diameter="30"></mat-spinner>
                        </ng-template>
                    </div>
                    <div class="text-container flex-column align-center-center">
                        <span class="text-title">{{ ('modules.cases.case-indicators.supply.supplies-not-delivered' | exp:'':'Pedidos no entregados') }}</span>
                    </div>
                </div>
            </app-theme-card>

            <!-- Attentions without billing -->
            <app-theme-card themeScope="cases" [fullWidth]="false" cardClass="flex-column align-center-center">
                <div [class.cursor-pointer]="this.counterSuppliesWithoutBilling != 0"  (click)="this.counterSuppliesWithoutBilling !== 0 && goToScreen(ViewManagementEntities.SUPPLIES_NOT_BILLING, suppliesWithoutBillingFlow)"
                    class="flex-column align-center-center cursor-pointer">
                    <div class="number-container">
                        <ng-container
                            *ngIf="this.isCounterSuppliesWithoutBilling && !this.btnsDisabled else loadingSuppliesWithoutBilling">
                            <span class="mat-display-1 number-font big-number"
                                [style.color]="this.colorSuppliesWithoutBilling">
                                {{ isCounterSuppliesWithoutBilling && !btnsDisabled ? this.counterSuppliesWithoutBilling
                                : '-' }}
                            </span>
                        </ng-container>
                        <ng-template #loadingSuppliesWithoutBilling>
                            <mat-spinner class="mr-3" color="primary" diameter="30"></mat-spinner>
                        </ng-template>
                    </div>
                    <div class="text-container flex-column align-center-center">
                        <span class="text-title">{{ ('modules.cases.case-indicators.supply.supplies-not-billing' | exp:'':'Insumos sin facturar') }}</span>
                    </div>
                </div>
            </app-theme-card>
            <!-- supply not delivered -->
            <app-theme-card themeScope="cases" [fullWidth]="false" cardClass="flex-column align-center-center"
                [cardStyle]="{ width: 'auto', height: '98%', 'border-radius': '0 1rem 1rem 0' }">
                <div  [class.cursor-pointer]="this.counterSuppliesNotInformed != 0"  (click)="this.counterSuppliesNotInformed !== 0 && goToScreen(ViewManagementEntities.SUPPLIES_NOT_INFORMED)"
                    class="flex-column align-center-center cursor-pointer">
                    <div class="number-container">
                        <ng-container
                            *ngIf="this.isCounterSuppliesNotInformed && !this.btnsDisabled else loadingSuppliesNotInformed">
                            <span class="mat-display-1 number-font big-number"
                                [style.color]="this.colorSuppliesNotInformed">
                                {{ isCounterSuppliesNotInformed && !btnsDisabled ? this.counterSuppliesNotInformed : '-'
                                }}
                            </span>
                        </ng-container>
                        <ng-template #loadingSuppliesNotInformed>
                            <mat-spinner class="mr-3" color="primary" diameter="30"></mat-spinner>
                        </ng-template>
                    </div>
                    <div class="text-container flex-column align-center-center">
                        <span class="text-title">{{ ('modules.cases.case-indicators.supply.supplies-not-informed' | exp:'':'Insumos sin informar') }}</span>
                    </div>
                </div>
            </app-theme-card>
        </div>
    </div>
</div>
